import { render } from "./ProductsEditorView.vue?vue&type=template&id=0086eab7&scoped=true"
import script from "./ProductsEditorView.vue?vue&type=script&lang=js"
export * from "./ProductsEditorView.vue?vue&type=script&lang=js"

import "./ProductsEditorView.vue?vue&type=style&index=0&id=0086eab7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0086eab7"]])

export default __exports__